import { Helmet } from 'react-helmet-async';
import Profilfive from './Grid/Grid';
import Gridcolor from './Grid/Gridcolor';
import s from './Peregorodki.module.scss';
import DemoCarousel from './Slider/Slider';
import typeone from './img/1type.jpg';
import typetwo from './img/2type.jpg';
import infotypeone from './img/infotypeone.jpg';
import infotypetwo from './img/infotypetwo.jpg';
import montagvotv from './img/montagvotv.jpg';
import threepolotna from './img/threepolotna.jpg';

const Peregorodki = () => {
  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>ЛАОЛА | РОЗСУВНІ ПЕРЕГОРОДКИ</title>
        <meta
          name="description"
          content="Система алюмінієвих розсувних перегородок. Продаж, проектування, встановлення. Найкраща якість! Вітчізняне виробництво."
        />
      </Helmet>
      <div className={s.peregorodkibox}>
        <div>
          <h1 className={s.titleper}>ПЕРЕГОРОДКИ</h1>
          <div>
            <ul className={s.infolistper}>
              <li className={s.infoper}>
                Система алюмінієвих розсувних перегородок – це відмінне рішення
                для поділу простору приміщення, а також сучасне та стильне
                доповнення до Вашого інтер'єру.
              </li>
              <li className={s.infoper}>
                Наше виробництво пропонує розсувні перегородки із алюмінієвих
                профілів вітчизняного виробництва, виготовлених з використанням
                останніх технологій.
              </li>
              <li className={s.infoper}>
                Колірні рішення профілю досягнуто шляхом порошкового фарбування.
                Як заповнення використовується скло триплекс. За роботу наших
                перегородок відповідає фурнітура європейського виробництва.
              </li>
            </ul>
          </div>
        </div>
        <div className={s.perslider}>
          <DemoCarousel />
        </div>
      </div>
      <div className={s.typeper}>
        <h1 className={s.titletypeper}>ТИПИ РОЗСУВНИХ ПЕРЕГОРОДОК</h1>
        <ul className={s.typeinfo}>
          <li>
            <h2>Каскад</h2>
            <img src={typeone} alt="" className={s.imgType} />

            <p>Розсувна конструкція із 3-4 полотен.</p>
            <p>
              Принцип дії системи: Одночасний (синхронний) рух полотен
              паралельно один одному в один бік. Кожне полотно в системі має
              власну направляючу, доводчик у системі «Каскад» відсутній. Монтаж
              конструкції можливий тільки в отворі (або до стелі). Конструкція
              виготовляється індивідуально під отвір замовника.
            </p>
            <img src={infotypeone} alt="" className={s.imgType} />
          </li>
          <li>
            <h2>КЛАСИЧНЕ ВІДКРИВАННЯ</h2>
            <img src={typetwo} alt="" className={s.imgType} />
            <p>
              Розсувна конструкція з 1-4 полотен (кількість полотен варіюється
              від типу монтажу конструкції, «перед отвором» настінний монтаж 1-2
              полотна, «в отворі» монтаж 2-4 полотна).
            </p>
            <p>
              Принцип дії системи: Монтаж «перед отвором»: система з двох
              полотен (або одного), кожне полотно рухається від центру отвору
              паралельно стіні на одній направлячій, відкриваючи отвір. Кожне
              полотно системи має доводчик, який дає напрямок в два положення,
              що забезпечує плавне закривання та відкривання.
            </p>
            <img src={infotypetwo} alt="" />
            <p>Монтаж «в отворі»:</p>

            <p>
              1. В системі з 2 полотен, полотна розташовуються в шаховому
              положенні, перебуваючи на різних направляючих. Обидва полотна
              рухаються у протилежний бік від вихідного базового положення.
              Кожне полотно системи має доводчик, який дає напрямок в два
              положення, що забезпечує плавне закривання та відкривання.
            </p>
            <img src={montagvotv} alt="" />

            <p>
              2. У системі з 3 або 4 полотен, полотна розміщуються на двох
              направляючих, розташованих паралельно один одному. Два крайні
              полотна розташовуються позаду і примикають до стіни, полотна є
              стаціонарними і не рухомими. Центральні полотна знаходяться у
              першому ряду конструкції, рух полотен відбувається у напрямку
              стаціонарних полотен від центру отвору. Доводчик розташований лише
              у активних полотнах.
            </p>
            <img src={threepolotna} alt="" className={s.imgType} />
          </li>
        </ul>
      </div>
      <div className={s.gridBox}>
        <h1 className={s.titletypeper}>ПРОФІЛЬ І МОДЕЛЬНИЙ РЯД</h1>
        <p>
          В основі виробництва розсувних перегородок закладено систему
          ексклюзивних алюмінієвих профілів
        </p>
        <Profilfive />
        <p>
          Можливе виготовлення моделей із серій AG, AV, AX або за кресленням
          клієнта (ціна базується від моделі за кількістю перемичок).
        </p>
      </div>
      <div className={s.gridBox}>
        <h1 className={s.titletypeper}>АЛЮМІНІЄВИЙ ПРОФІЛЬ</h1>
        <Gridcolor />
        <p>
          Виготовлення алюмінієвої перегородки в іншому кольорі обговорюється
          індивідуально.
        </p>
        <h3>Переваги:</h3>
        <ul>
          <li>Надійний захист від корозії;</li>
          <li>
            Висока естетика покриття та декоративні властивості. Алюмінієвий
            профіль виглядає благороднішим і багатшим, що розширює межі в
            дизайні;
          </li>
          <li>
            Висока стійкість до ультрафіолетового випромінювання (не вигоряє);
          </li>
          <li>
            Підвищена стійкість до механічних пошкоджень (подряпин, потертостей
            та ін.) завдяки поліпшенню таких властивостей алюмінію як твердість,
            стійкість до термічного впливу (не дряпається, якщо тільки цвяхом).
          </li>
        </ul>
      </div>
    </>
  );
};

export default Peregorodki;
